import Vue from 'vue';
import Axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import { toData, to } from './promiseHandle';

export class LoginService extends Vue {
    private baseAPI = process.env.VUE_APP_API_URL;
    private commonAPI = process.env.VUE_APP_API_COMMON_URL;
    private token = localStorage.getItem('token');

    private headers: any = { 'Content-Type': 'application/json' };

    private headersWithToken: any = { 'Content-Type': 'application/json',
        'auth': localStorage.getItem('token') };

    // // ===== Request Method =====

    public async get(url: string, header?: any) {
        return await to(Axios.get<AxiosResponse>(url, { headers: { ...this.headers, ...header } }));
    }

    public async post(url: string, body: any, header?: any) {
        return await to(Axios.post<AxiosResponse>(url, body, { headers: { ...this.headers, ...header } }));
    }

    public async put(url: string, body?: any, header?: any) {
        return await to(Axios.put<AxiosResponse>(url, body, { headers: { ...this.headers, ...header } }));
    }

    public async delete(url: string, header?: any) {
        return await to(Axios.delete(url, { headers: { ...this.headers, ...header } }));
    }

    public async postWithToken(url: string, body: any, header?: any) {
        return await to(Axios.post<AxiosResponse>(url, body, { headers: { ...this.headersWithToken, ...header } }));
    }

    // // ===== Request Method =====


    public async loginStaff(data?: any) {
        const { result, error } = await this.postWithToken(`${this.baseAPI}/staff/auth`, {
            staffCd: data ? data.username : '',
            pass: data ? data.password : '',
        });

        if (result) {
            return { status: result.status, result: result.data };
        } else {
            return { status: error.status, error: error.data };
        }
    }

    public async login(data?: any) {
        const { result, error } = await this.post(`${this.baseAPI}/auth/token`, {
            id: data ? data.username : '',
            pass: data ? data.password : '',
        });
        if (result) {
            return { status: result.status, result: result.data };
        } else if (error) {
            return { status: error.status, error: error.data };
        }
        return {};
    }

    public async shakenInitial() {
        const { result, error } = await this.post(`${this.baseAPI}/shaken/initial`, null, this.headersWithToken);
        if (result) {
            return { status: result.status, result: result.data };
        } else {
            return { status: error.status, error: error.data };
        }
    }

    public async refreshToken(token?: any) {
        return await this.put(`${this.baseAPI}/auth/token`, null, { auth: token });
    }

    public async removeToken(token?: any) {
        return await this.delete(`${this.baseAPI}/auth/token`, { auth: token });
    }
}
